import { Modal, Button, Form, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { FaEdit, FaSave, FaTimes, FaTrash } from "react-icons/fa";

function AddDeviceModal({ show, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [deviceData, setDeviceData] = useState({
    location: "",
    serial_number: "",
  });

  const fetchDevices = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/users/add-new-device/`, {
        headers: HEADERS,
      });
      setDevices(res.data?.results || []);
    } catch {
      toast.error("Failed to load devices");
    }
  };

  useEffect(() => {
    if (show) fetchDevices();
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeviceData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setDeviceData({ location: "", serial_number: "" });
    setEditingId(null);
  };

  const handleSubmit = async () => {
    if (!deviceData.location || !deviceData.serial_number) {
      toast.error("Both fields are required");
      return;
    }

    try {
      setLoading(true);

      if (editingId) {
        await axios.put(
          `${BASE_URL}/users/add-new-device/${editingId}/`,
          deviceData,
          { headers: HEADERS }
        );
        toast.success("Device updated successfully");
      } else {
        await axios.post(
          `${BASE_URL}/users/add-new-device/`,
          deviceData,
          { headers: HEADERS }
        );
        toast.success("Device added successfully");
      }

      resetForm();
      fetchDevices();
    } catch {
      toast.error("Operation failed");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (device) => {
    setEditingId(device.id);
    setDeviceData({
      location: device.location,
      serial_number: device.serial_number,
    });
  };

  const handleDelete = async (id) => {
    

    try {
      await axios.delete(
        `${BASE_URL}/users/add-new-device/${id}/`,
        { headers: HEADERS }
      );
      toast.success("Device deleted successfully");
      fetchDevices();
    } catch {
      console.error("Failed to delete device");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Manage Devices</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "65vh", overflowY: "auto" }}>
        {/* ADD / EDIT FORM */}
        <div className="mb-2 p-2 border rounded">
          <h6 className="mb-2">
            {editingId ? "Edit Device" : "Add New Device"}
          </h6>

          <Form className="d-flex gap-2 align-items-center flex-wrap">
            <Form.Control
              size="sm"
              placeholder="Location"
              name="location"
              value={deviceData.location}
              onChange={handleChange}
              style={{ flex: 1, minWidth: "150px" }}
            />

            <Form.Control
              size="sm"
              placeholder="Serial Number"
              name="serial_number"
              value={deviceData.serial_number}
              onChange={handleChange}
              style={{ flex: 1, minWidth: "150px" }}
            />

            <Button
              size="sm"
              variant="primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {editingId ? <FaSave /> : "Add"}
            </Button>

            {editingId && (
              <Button size="sm" variant="secondary" onClick={resetForm}>
                <FaTimes />
              </Button>
            )}
          </Form>
        </div>

        <Table size="sm" hover responsive className="mb-0">
          <thead>
            <tr style={{ fontSize: "12px" }}>
              <th style={{ padding: "6px" }}>Location</th>
              <th style={{ padding: "6px" }}>Serial No</th>
              <th style={{ padding: "6px", width: "80px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {devices.length > 0 ? (
              devices.map((device) => (
                <tr key={device.id} style={{ fontSize: "12px" }}>
                  <td style={{ padding: "4px 6px" }}>
                    {device.location}
                  </td>
                  <td style={{ padding: "4px 6px" }}>
                    {device.serial_number}
                  </td>
                  <td style={{ padding: "4px 6px" }}>
                    <Button
                      size="sm"
                      variant="link"
                      className="p-0 me-2"
                      disabled={editingId === device.id}
                      onClick={() => handleEdit(device)}
                    >
                      <FaEdit />
                    </Button>

                    <Button
                      size="sm"
                      variant="link"
                      className="p-0 text-danger"
                      onClick={() => handleDelete(device.id)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center text-muted py-3">
                  No devices found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddDeviceModal;
